import Prestigio from "../assets/images/pizzas/doces/prestigio.jpeg";
import Brigadeiro from "../assets/images/pizzas/doces/brigadeiro.jpeg";
import Choconfete from "../assets/images/pizzas/doces/choconfete.jpeg";
import RomeuEJulieta from "../assets/images/pizzas/doces/romeuEJulieta.jpeg";

import CalabresaEspecial from "../assets/images/pizzas/especiais/calabresaEspecial.jpeg";
import CarneSupreme from "../assets/images/pizzas/especiais/carneSupreme.jpeg";
import DuChefe from "../assets/images/pizzas/especiais/duchefe.jpg";
import EstrogonofeFrango from "../assets/images/pizzas/especiais/estrogonofeFrango.jpeg";
import EstrogonofeCarne from "../assets/images/pizzas/especiais/estrogonofeCarne.jpg";
import QuatroQueijos from "../assets/images/pizzas/especiais/quatroQueijos.jpeg";
import DaRocaEspecial from "../assets/images/pizzas/especiais/daRocaEspecial.jpeg";
import CalaFrangoEspecial from "../assets/images/pizzas/especiais/calafrangoEspecial.jpeg";
import CalaBaconEspecial from "../assets/images/pizzas/especiais/calabaconEspecial.jpeg";
import RottaEspecial from "../assets/images/pizzas/especiais/rottaEspecial.jpg";
import RondonopolisEspecial from "../assets/images/pizzas/especiais/rondonopolisEspecial.jpg";
import FranBaconEspecial from "../assets/images/pizzas/especiais/franbaconEspecial.jpg";
import MeioMetroEsp from "../assets/images/pizzas/especiais/meioMetro.jpeg";
import familiaEspecial from "../assets/images/pizzas/especiais/familiaEspecial.jpg";

import Bacon from "../assets/images/pizzas/tradicionais/bacon.jpeg";
import BaconCheddar from "../assets/images/pizzas/tradicionais/baconCheddar.jpeg";
import Brocolis from "../assets/images/pizzas/tradicionais/brocolis.jpg";
import Calabresa from "../assets/images/pizzas/tradicionais/calabresa.jpeg";
import CalaFrango from "../assets/images/pizzas/tradicionais/calafrango.jpeg";
import Cremosa from "../assets/images/pizzas/tradicionais/cremosa.jpeg";
import Crocante from "../assets/images/pizzas/tradicionais/crocante.jpeg";
import DaRoca from "../assets/images/pizzas/tradicionais/daroca.jpg";
import FranBacon from "../assets/images/pizzas/tradicionais/franBacon.jpeg";
import FrangoCatupiry from "../assets/images/pizzas/tradicionais/frangoCatupiry.jpeg";
import Picante from "../assets/images/pizzas/tradicionais/picante.jpeg";
import Portuguesa from "../assets/images/pizzas/tradicionais/portuguesa.jpeg";
import PresuntoEQueijo from "../assets/images/pizzas/tradicionais/presuntoEQueijo.jpeg";
import Rondonopolis from "../assets/images/pizzas/tradicionais/rondonopolis.jpg";
import Rota from "../assets/images/pizzas/tradicionais/rota.jpeg";
import TresQueijos from "../assets/images/pizzas/tradicionais/tresQueijos.jpeg";
import FrangoCheddar from "../assets/images/pizzas/tradicionais/frangoCheddar.jpg";
import Caipira from "../assets/images/pizzas/tradicionais/caipira.jpeg";
import MeioMetroTrad from "../assets/images/pizzas/tradicionais/meioMetro.jpeg";
import familiaTradicional from "../assets/images/pizzas/tradicionais/familiaTradicional.jpg";

export const pizzas = {
    combos: [
        {
            nome: "Combo de Pizzas Tradicionais",
            ingredientes: "2 Pizzas G + 1 Pizza P",
            valor: 130,
            opcoes: "tradicionais",
            tipo: "combo",
            image: "",
        },
        {
            nome: "Combo de Pizzas Especiais",
            ingredientes: "1 Pizza G + 1 Pizza P",
            opcoes: "especiais",
            valor: 100,
            tipo: "combo",
            image: "",
        }
    ],
    doces: [
        {
            nome: "Prestígio",
            ingredientes: "Massa, mussarela, coco e chocolate ao leite",
            valor: 50,
            tipo: "doce",
            image: Prestigio,
        },
        {
            nome: "Brigadeiro",
            ingredientes: "Massa, mussarela, granulado e chocolate ao leite",
            valor: 50,
            tipo: "doce",
            image: Brigadeiro,
        },
        {
            nome: "Choconfete",
            ingredientes: "Massa, mussarela, confete e chocolate ao leite",
            valor: 50,
            tipo: "doce",
            image: Choconfete,
        },
        
        {
            nome: "Romeu e Julieta",
            ingredientes: "Massa, mussarela e goiabada",
            valor: 50,
            tipo: "doce",
            image: RomeuEJulieta,
        },
    ],
    meioMetro: [
        {
            nome: "Pizza Meio Metro Tradicional (50cm)",
            ingredientes: "Escolha até 2 sabores de pizzas tradicionais",
            valor: 80,
            tipo: "tradicional/meioMetro",
            image: MeioMetroTrad,
        },
        {
            nome: "Pizza Meio Metro Especial (50cm)",
            ingredientes: "Escolha até 2 sabores de pizzas especiais",
            valor: 100,
            tipo: "especial/meioMetro",
            image: MeioMetroEsp,
        },
    ],
    tradicionais: [
        {
            nome: "Pizza Tamanho Família",
            ingredientes: "Pizza de 12 pedaços, escolha até 4 sabores de pizzas tradicionais",
            valor: 90,
            tipo: "tradicional/familia",
            image: familiaTradicional,
            combo: false,
        },
        {
            nome: "3 Queijos",
            ingredientes: "Molho, queijo, catupiry, cheddar, azeitona e orégano",
            valor: 50,
            tipo: "tradicional",
            image: TresQueijos,
            combo: true,
        },
        {
            nome: "Bacon",
            ingredientes: "Molho, queijo, bacon, azeitona e orégano",
            valor: 50,
            tipo: "tradicional",
            image: Bacon,
            combo: true,
        },
        {
            nome: "Bacon Cheddar",
            ingredientes: "Molho, queijo, cheddar, bacon, azeitona e orégano",
            valor: 50,
            tipo: "tradicional",
            image: BaconCheddar,
            combo: true,
        },
        {
            nome: "Brócolis",
            ingredientes: "Molho, queijo, brócolis, bacon, azeitona e orégano",
            valor: 50,
            tipo: "tradicional",
            image: Brocolis,
            combo: true,
        },
        {
            nome: "Caipira",
            ingredientes: "Molho, queijo, frango, milho, azeitona e orégano",
            valor: 50,
            tipo: "tradicional",
            image: Caipira,
            combo: true,
        },
        {
            nome: "Calabresa",
            ingredientes: "Molho, queijo, azeitona, calabresa, cebola e orégano",
            valor: 50,
            tipo: "tradicional",
            image: Calabresa,
            combo: true,
        },
        {
            nome: "Calafrango",
            ingredientes: "Molho, queijo, frango, calabresa, azeitona e orégano",
            valor: 50,
            tipo: "tradicional",
            image: CalaFrango,
            combo: false,
        },
        {
            nome: "Cremosa",
            ingredientes: "Molho, queijo, catupiry, azeitona e orégano",
            valor: 50,
            tipo: "tradicional",
            image: Cremosa,
            combo: true,
        },
        {
            nome: "Crocante",
            ingredientes: "Molho, queijo, catupiry, azeitona, batata palha e orégano",
            valor: 50,
            tipo: "tradicional",
            image: Crocante,
            combo: true,
        },
        {
            nome: "Dá Roça",
            ingredientes: "Molho, queijo, presunto, bacon, milho, azeitona e orégano",
            valor: 50,
            tipo: "tradicional",
            image: DaRoca,
            combo: false,
        },
        {
            nome: "Franbacon",
            ingredientes: "Molho, queijo, frango, bacon, azeitona e orégano",
            valor: 50,
            tipo: "tradicional",
            image: FranBacon,
            combo: false,
        },
        {
            nome: "Frango Catupiry",
            ingredientes: "Molho, queijo, catupiry, frango, azeitona e orégano",
            valor: 50,
            tipo: "tradicional",
            image: FrangoCatupiry,
            combo: true,
        },
        {
            nome: "Frango Cheddar",
            ingredientes: "Molho, queijo, frango, cheddar, azeitona e orégano",
            valor: 50,
            tipo: "tradicional",
            image: FrangoCheddar,
            combo: true,
        },
        {
            nome: "Picante",
            ingredientes: "Molho, queijo, presunto, cebola, pimenta calabresa, azeitona e orégano",
            valor: 50,
            tipo: "tradicional",
            image: Picante,
            combo: true,
        },
        {
            nome: "Portuguesa",
            ingredientes: "Molho, queijo, presunto, cebola, azeitona, ovo, pimentão e orégano",
            valor: 50,
            tipo: "tradicional",
            image: Portuguesa,
            combo: true,
        },
        {
            nome: "Presunto e Queijo",
            ingredientes: "Molho, queijo, presunto, tomate, azeitona e orégano",
            valor: 50,
            tipo: "tradicional",
            image: PresuntoEQueijo,
            combo: true,
        },
        {
            nome: "Rondonópolis",
            ingredientes: "Molho, queijo, presunto, tomate, ovo, cebola, calabresa, azeitona e orégano",
            valor: 50,
            tipo: "tradicional",
            image: Rondonopolis,
            combo: false,
        },
        {
            nome: "Rotta",
            ingredientes: "Molho, queijo, calabresa, bacon, cebola, pimentão, azeitona e orégano",
            valor: 50,
            tipo: "tradicional",
            image: Rota,
            combo: false,
        }
    ],
    especiais: [
        {
            nome: "Pizza Tamanho Família",
            ingredientes: "Pizza de 12 pedaços, escolha até 4 sabores de pizzas especiais",
            valor: 110,
            tipo: "especial/familia",
            image: familiaEspecial,
            combo: false,
        },
        {
            nome: "Calabresa Especial",
            ingredientes: "Molho, queijo, catupiry original, cebola, calabresa, azeitona e orégano",
            valor: 70,
            tipo: "especial",
            image: CalabresaEspecial,
        },
        {
            nome: "Calabacon Especial",
            ingredientes: "Molho, queijo, calabresa, bacon, azeitona, orégano e catupiry original",
            valor: 70,
            tipo: "especial",
            image: CalaBaconEspecial,
        },
        {
            nome: "Carne Supreme",
            ingredientes: "Molho, queijo, catupiry original, tomate cereja, carne lagarto, azeitona e orégano",
            valor: 70,
            tipo: "especial",
            image: CarneSupreme,
        },
        {
            nome: "Duchefe",
            ingredientes: "Molho, queijo, frango, catupiry original, calabresa, bacon, azeitona e orégano",
            valor: 70,
            tipo: "especial",
            image: DuChefe,
        },
        {
            nome: "Quatro Queijos",
            ingredientes: "Molho, mussarela, provolone, parmesão, catupiry, azeitona e orégano",
            valor: 70,
            tipo: "especial",
            image: QuatroQueijos,
        },
        {
            nome: "Strogonoff de frango",
            ingredientes: "Molho, mussarela, strogonoff de frango, batata palha, azeitona e orégano",
            valor: 70,
            tipo: "especial",
            image: EstrogonofeFrango,
        },
        {
            nome: "Strogonoff de carne",
            ingredientes: "Molho, mussarela, strogonoff de carne, batata palha, azeitona e orégano",
            valor: 70,
            tipo: "especial",
            image: EstrogonofeCarne,
        },
        {
            nome: "Franbacon Especial",
            ingredientes: "Molho, queijo, frango, bacon, azeitona, orégano e catupiry original",
            valor: 70,
            tipo: "especial",
            image: FranBaconEspecial,
        },
        {
            nome: "Rondonópolis Especial",
            ingredientes: "Molho, queijo, presunto, tomate, ovo, cebola, calabresa, azeitona, orégano e catupiry original",
            valor: 70,
            tipo: "especial",
            image: RondonopolisEspecial,
        },
        {
            nome: "Calafrango Especial",
            ingredientes: "Molho, queijo, frango, calabresa, azeitona, orégano e catupiry original",
            valor: 70,
            tipo: "especial",
            image: CalaFrangoEspecial,
        }, 
        {
            nome: "Rotta Especial",
            ingredientes: "Molho, queijo, calabresa, bacon, cebola, pimentão, azeitona orégano e catupiry original",
            valor: 70,
            tipo: "especial",
            image: RottaEspecial,
        },
        {
            nome: "Dá Roça Especial",
            ingredientes: "Molho, queijo, presunto, bacon, milho, azeitona, orégano e catupiry original",
            valor: 70,
            tipo: "especial",
            image: DaRocaEspecial,
        }
    ],
    adicionais: [
        {
            nome: "Carne",
            valor: 15,
        },
        {
            nome: "4 Queijos",
            valor: 15,
        },
        {
            nome: "Catupiry Original",
            valor: 15,
        },
        {
            nome: "Borda de Catupiry Original",
            valor: 15,
        },
        {
            nome: "Borda de Chocolate",
            valor: 15,
        },
        {
            nome: "Queijo",
            valor: 15,
        },
        {
            nome: "Bacon",
            valor: 15,
        },
        {
            nome: "Frango",
            valor: 15,
        },
        {
            nome: "Presunto",
            valor: 15,
        },
        {
            nome: "Calabresa",
            valor: 15,
        },
        {
            nome: "Borda de goiabada",
            valor: 7,
        },
        {
            nome: "Borda de Requeijão",
            valor: 7,
        },
        {
            nome: "Borda de Cheddar",
            valor: 7,
        },
        {
            nome: "Cheddar",
            valor: 7,
        },
        {
            nome: "Pimentão",
            valor: 7,
        },
        {
            nome: "Milho",
            valor: 7,
        },
        {
            nome: "Ovo",
            valor: 7,
        },
        {
            nome: "Tomate",
            valor: 7,
        },
        {
            nome: "Batata palha",
            valor: 7,
        },
        {
            nome: "Cebola",
            valor: 7,
        },
    ],
    adicionaisDoce: [
        {
            nome: "Granulado",
            valor: 0,
        },
        {
            nome: "Coco ralado",
            valor: 0,
        },
        {
            nome: "Confete",
            valor: 0,
        }
    ],
    refrigerantes: [
        {
            nome: "Kitubaína 2L",
            valor: 12,
        },
        {
            nome: "Coca Cola 2L",
            valor: 17,
        }
    ]
};